import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "input-group mb-2"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "ID:", -1)
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  for: "productName",
  class: "form-label"
}, "Název:", -1)
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  for: "productPrice",
  class: "form-label"
}, "Cena:", -1)
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "productCategory",
  class: "form-label"
}, "Kategorie:", -1)
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "form-check mb-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckDefault"
}, " Je dostupný ", -1)
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "formFile",
  class: "form-label"
}, "Obrázek produktu:", -1)
const _hoisted_14 = { key: 0 }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "d-flex flex-row-reverse" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }

import { useProductFormStore } from '@/store/ProductStore';
import Modal from "@/components/Modal.vue";
import { Product } from '@/types/Product';
import { ref } from '@vue/reactivity';
import { categoriesTranslation } from '@/types/ProductCategory';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductForm',
  setup(__props, { expose }) {
const productFormStore = useProductFormStore();
// const categoriesList = [
//     {val:"Food", text:"Jídlo"},
//     {val:"Drink", text:"Pití"},
//     {val:"Other", text:"Drobnosti"}
// ];


const modal = ref<InstanceType<typeof Modal>>();

function createNew(){
    previewUrl.value = "";
    productFormStore.startNew();
    modal.value?.show();
}
function update(product: Product){
    previewUrl.value = "";
    productFormStore.startModify(product);
    modal.value?.show();
}
expose({
    createNew,
    update
});

function submit(){
    productFormStore.submit();
    modal.value?.close();
}

const previewUrl = ref<string>("");
previewUrl.value = "";
function fileChanged(e:Event){
    const target = e.target as HTMLInputElement;
    if(target.files != null)
    {
        const file = target?.files[0];
        if(file!=null){
            productFormStore.newImageFile = file;
            console.log(file);
            const fileUrl = URL.createObjectURL(file);
            console.log(fileUrl);
            previewUrl.value = fileUrl;
        }
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    ref_key: "modal",
    ref: modal,
    title: _unref(productFormStore).isMakingNew?'Nový produkt':'Upravit produkt'
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", null, [
        (!_unref(productFormStore).isMakingNew)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _hoisted_2,
              _withDirectives(_createElementVNode("input", {
                type: "number",
                class: "form-control",
                disabled: "",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(productFormStore).id) = $event))
              }, null, 512), [
                [_vModelText, _unref(productFormStore).id]
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            id: "productName",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(productFormStore).name) = $event))
          }, null, 512), [
            [_vModelText, _unref(productFormStore).name]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _withDirectives(_createElementVNode("input", {
            type: "number",
            class: "form-control",
            id: "productPrice",
            pattern: "^\\d*(\\.\\d{0,2})?$",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(productFormStore).price) = $event))
          }, null, 512), [
            [_vModelText, _unref(productFormStore).price]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _withDirectives(_createElementVNode("select", {
            id: "productCategory",
            class: "form-select",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(productFormStore).category) = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(categoriesTranslation), (category) => {
              return (_openBlock(), _createElementBlock("option", {
                key: category.val,
                value: category.val
              }, _toDisplayString(category.text), 9, _hoisted_9))
            }), 128))
          ], 512), [
            [_vModelSelect, _unref(productFormStore).category]
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _withDirectives(_createElementVNode("input", {
            class: "form-check-input",
            id: "productAvailable",
            type: "checkbox",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(productFormStore).isAvailable) = $event))
          }, null, 512), [
            [_vModelCheckbox, _unref(productFormStore).isAvailable]
          ]),
          _hoisted_11
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("input", {
            class: "form-control",
            type: "file",
            id: "formFile",
            onChange: fileChanged
          }, null, 32),
          (!_unref(previewUrl))
            ? (_openBlock(), _createElementBlock("label", _hoisted_14, "Obrázek nebude změněn"))
            : _createCommentVNode("", true),
          (_unref(previewUrl))
            ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                class: "mt-2",
                src: _unref(previewUrl),
                width: "160",
                height: "90"
              }, null, 8, _hoisted_15))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: _withModifiers(submit, ["prevent"])
          }, [
            (_unref(productFormStore).isMakingNew)
              ? (_openBlock(), _createElementBlock("span", _hoisted_18, "Přidat produkt"))
              : (_openBlock(), _createElementBlock("span", _hoisted_19, "Změnit produkt"))
          ], 8, _hoisted_17),
          _createElementVNode("button", {
            class: "btn btn-outline-danger me-3",
            onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_unref(modal)?.close && _unref(modal)?.close(...args)), ["prevent"]))
          }, " Zrušit ")
        ])
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})